import React, { Fragment } from 'react';
import Footer from './Footer';

class Body extends React.Component {
    render() {
        return (
            <div className="sf-body sd-body sg-body page-overflow">
                <Fragment>
                    {this.props.children}
                </Fragment>
                <Footer />
            </div>
        );
    }
}

export default Body